"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/ETFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_71)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_71`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V8H-6V0Z",
					fill: "#20AA46"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 16H30V24H-6V16Z",
					fill: "#E92F3B"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 8H30V16H-6V8Z",
					fill: "#FADF50"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.08 20.32C16.675 20.32 20.4 16.595 20.4 12C20.4 7.40498 16.675 3.67999 12.08 3.67999C7.485 3.67999 3.76001 7.40498 3.76001 12C3.76001 16.595 7.485 20.32 12.08 20.32Z",
					fill: "#205CCA"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.99999 12.64L8.71999 16.48L12.08 14.08L15.44 16.48L14.16 12.64M9.99999 12.64L6.79999 10.24H10.8L12.08 6.56L13.36 10.24H17.52L14.16 12.64M9.99999 12.64L10.96 9.76M14.16 12.64L11.6 14.4M10.48 10.24H13.52M9.83999 12.48L11.92 14.08M13.2 9.92L14.32 12.8",
					stroke: "#FFDB3D",
					strokeWidth: .8
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.91999 6.24002L9.67999 8.80002M16.08 6.08002L14.48 8.64002M12.08 16.16V19.2M8.23998 13.28L5.35999 14.4M18.8 14.4L15.92 13.28",
					stroke: "#FFDB3D",
					strokeWidth: .4
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_71`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as ETFlag };
